<div class="flex flex-col">
  <div class="flex flex-0 sticky top-0 z-50 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
    <div class="text-lg font-medium">
      <b>{{ 'errorDetails.errorDetail' | transloco}}</b>
    </div>
    <button mat-icon-button (click)="closeDialog()" [tabIndex]="-1">
      <mat-icon class="text-on-primary" [svgIcon]="'mat_outline:close'"></mat-icon>
    </button>
  </div>
  <mat-dialog-content class="text-gray-800 dark:text-gray-100 max-h-[70vh] overflow-y-auto px-6 dark:bg-default">

    <!-- Main Error Info -->
    <div class="mb-6 p-4 bg-gray-50 dark:bg-slate-800 border rounded-lg">

      <h3 class="mt-0 mb-4 text-base font-semibold">{{ 'errorDetails.section.errorInformation' | transloco }}</h3>
      <div class="grid grid-cols-[300px_1fr] gap-4 py-2 border-b border-gray-200 dark:border-gray-700">
        <span class="font-medium text-gray-600 dark:text-gray-400">{{ 'errorDetails.error' | transloco }}:</span>
        <span class="break-words">{{ errorDetails.error }}</span>
      </div>
      <div class="grid grid-cols-[300px_1fr] gap-4 py-2 border-b border-gray-200 dark:border-gray-700">
        <span class="font-medium text-gray-600 dark:text-gray-400">{{ 'errorDetails.status' | transloco }}:</span>
        <span class="break-words">{{ errorDetails.status }}</span>
      </div>
      <div class="grid grid-cols-[300px_1fr] gap-4 py-2 border-b border-gray-200 dark:border-gray-700">
        <span class="font-medium text-gray-600 dark:text-gray-400">{{ 'errorDetails.statusInNet4' | transloco }}:</span>
        <span class="break-words">{{ errorDetails.statusInNet4 }}</span>
      </div>
      <div class="grid grid-cols-[300px_1fr] gap-4 py-2">
        <span class="font-medium text-gray-600 dark:text-gray-400">{{ 'errorDetails.timestamp' | transloco }}:</span>
        <span class="break-words">{{ errorDetails.timestamp }}</span>
      </div>
    </div>

    <!-- Net4 Error Details -->
    @if (errorDetails.net4Error) {
      <div class="mb-6 p-4 bg-gray-50 dark:bg-slate-800 border rounded-lg">
        <h3 class="mt-0 mb-4 text-base font-semibold">{{ 'errorDetails.section.net4Error' | transloco }}</h3>
        <div class="grid grid-cols-[300px_1fr] gap-4 py-2 border-b border-gray-200 dark:border-gray-700">
          <span class="font-medium text-gray-600 dark:text-gray-400">{{ 'errorDetails.net4.apiMethod' | transloco }}:</span>
          <span class="break-words">{{ errorDetails.net4Error.apiMethod }}</span>
        </div>
        <div class="grid grid-cols-[300px_1fr] gap-4 py-2 border-b border-gray-200 dark:border-gray-700">
          <span class="font-medium text-gray-600 dark:text-gray-400">{{ 'errorDetails.net4.duration' | transloco }}:</span>
          <span class="break-words">{{ errorDetails.net4Error.ms }} ms</span>
        </div>
        <div class="grid grid-cols-[300px_1fr] gap-4 py-2 border-b border-gray-200 dark:border-gray-700">
          <span class="font-medium text-gray-600 dark:text-gray-400">{{ 'errorDetails.net4.remark' | transloco }}:</span>
          <span class="break-words">{{ errorDetails.net4Error.remark }}</span>
        </div>
        <div class="grid grid-cols-[300px_1fr] gap-4 py-2 border-b border-gray-200 dark:border-gray-700">
          <span class="font-medium text-gray-600 dark:text-gray-400">{{ 'errorDetails.net4.timestamp' | transloco }}:</span>
          <span class="break-words">{{ errorDetails.net4Error.timestamp }}</span>
        </div>
        <div class="grid grid-cols-[300px_1fr] gap-4 py-2 border-b border-gray-200 dark:border-gray-700">
          <span class="font-medium text-gray-600 dark:text-gray-400">{{ 'errorDetails.net4.status' | transloco }}:</span>
          <span class="break-words">{{ errorDetails.net4Error.status }}</span>
        </div>
        <div class="grid grid-cols-[300px_1fr] gap-4 py-2">
          <span class="font-medium text-gray-600 dark:text-gray-400">{{ 'errorDetails.net4.statusInNet4' | transloco }}:</span>
          <span class="break-words">{{ errorDetails.net4Error.statusInNet4 }}</span>
        </div>
      </div>
    }

    <!-- Request Details -->
    @if (errorDetails.net4Error) {
      <div class="mb-6 p-4 bg-gray-50 dark:bg-slate-800 border rounded-lg">
        <div class="flex flex-row gap-2 items-center mb-4">
          <h3 class="mt-0 text-base font-semibold">{{ 'errorDetails.section.request' | transloco }}</h3>
          <button mat-icon-button (click)="copyJsonToClipboard(errorDetails.net4Error.request)" [matTooltip]="'errorDetails.copyJsonToClipboard' | transloco">
            <mat-icon [svgIcon]="'heroicons_outline:clipboard-document-list'"></mat-icon>
          </button>
        </div>
        @for (field of getRequestFields(); track $index) {
          <div class="grid grid-cols-[300px_1fr] gap-4 py-2 border-b border-gray-200 dark:border-gray-700">
            <span class="font-medium text-gray-600 dark:text-gray-400">{{ field.label| transloco }}:</span>
            <span class="break-words">{{ field.value }}</span>
          </div>
        }
      </div>
    }

    <!-- Response Details -->
    @if (errorDetails.net4Error) {
      <div class="mb-6 p-4 bg-gray-50 dark:bg-slate-800 border rounded-lg">
        <div class="flex flex-row gap-2 items-center mb-4">
          <h3 class="mt-0 text-base font-semibold">{{ 'errorDetails.section.response' | transloco }}</h3>
          <button mat-icon-button (click)="copyJsonToClipboard(errorDetails.net4Error.response)">
            <mat-icon [svgIcon]="'heroicons_outline:clipboard-document-list'"></mat-icon>
          </button>
        </div>
        <div class="grid grid-cols-[300px_1fr] gap-4 py-2 border-b border-gray-200 dark:border-gray-700">
          <span class="font-medium text-gray-600 dark:text-gray-400">{{ 'errorDetails.response.status' | transloco }}:</span>
          <span class="break-words">{{ errorDetails.net4Error.response.status }}</span>
        </div>
        <div class="grid grid-cols-[300px_1fr] gap-4 py-2 border-b border-gray-200 dark:border-gray-700">
          <span class="font-medium text-gray-600 dark:text-gray-400">{{ 'errorDetails.response.signed' | transloco }}:</span>
          <span class="break-words">{{ errorDetails.net4Error.response.signed ? ('errorDetails.response.yes' | transloco) : ('errorDetails.response.no' | transloco) }}</span>
        </div>
        <div class="grid grid-cols-[300px_1fr] gap-4 py-2">
          <span class="font-medium text-gray-600 dark:text-gray-400">{{ 'errorDetails.response.message' | transloco }}:</span>
          <span class="break-words">{{ errorDetails.net4Error.response.message?.[0] }}</span>
        </div>
      </div>
    }
  </mat-dialog-content>
